module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAAINJREFUKFNjZGBgYDxz5gyLiYnJbwYsgHHT1p15jAwMBX+Y/jkFeno+QFfDuHnzZhEGZta9jP8Z+X4z/XNEV8QI0rF5834RBuafWBWBFeBTBFeASxGKAnRFLMz/jXEo+LWX8T8DH4YCiGMhkjAfoTkSVRJkJZI3MSXBCggGFMGgJhRZAKjvaINg7ZPuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/more_arrow.png
// module id = 1dDv
// module chunks = 76